export default "__VITE_ASSET__WKFTXpjT__"